import styled from 'styled-components';

interface AgreementModalProps {
    onClose: () => void;
}

const AgreementModal = ({ onClose }: AgreementModalProps) => {
    return (
        <Wrap>
            <Modal className='abs xy-middle'>
                <button className='img-box x-btn abs' onClick={onClose}>
                    <img src="./img/ico_x_point_0052FF.svg" alt="" />
                </button>
                <div className="text-area">
                    <h1 className='tb'>개인정보 수집 및 이용 동의 (필수)</h1>
                    <ul className='flex fdc'>
                        <li className='flex fdc'>
                            <h2 className='tsb'>수집·이용 목적</h2>
                            <p>문의내용 확인 및 답변을 위해 수집·이용됨</p>
                        </li>
                        <li className='flex fdc'>
                            <h2 className='tsb'>수집항목</h2>
                            <p>이름, 휴대폰번호, 이메일</p>
                        </li>
                        <li className='flex fdc'>
                            <h2 className='tsb'>보유 및 이용기간</h2>
                            <p>3년간 보유 및 이용 이후 파기</p>
                        </li>
                        <li className='flex fdc'>
                            <h2 className='tsb'>동의거부 권리 알림</h2>
                            <p>개인정보 수집·이용에 대하여 동의를 거부할 수 있으며, 동의를 하지 않으면 서비스 관련 문의를 할 수 없습니다.</p>
                        </li>
                    </ul>
                </div>
            </Modal>
        </Wrap>
    );
}

export default AgreementModal;

const Wrap = styled.div`
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5;
`
const Modal = styled.div`
    width: 1162px;
    box-sizing: border-box;
    padding: 100px;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.16);
    @media (max-width: 1400px) {
        width: 83vw;
        padding: 7.1428vw;
        border-radius: 1.4285vw;
        box-shadow: 0px 0.1428vw 1vw 0px rgba(0, 0, 0, 0.16);
    }
    @media (max-width: 767px) {
        width: 100%;
        max-width: 90%;
        padding: 60px 20px 20px 20px;
        border-radius: 20px;
        box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.16);
    }
    
    > .x-btn {
        width: 28px;
        top: 24px;
        right: 24px;
        @media (max-width: 1400px) {
            width: 2vw;
            top: 1.7142vw;
            right: 1.7142vw;
        }
        @media (max-width: 767px) {
            width: 28px;
            top: 20px;
            right: 20px;
        }
    }

    .text-area {
        > h1 {
            font-size: 24px;
            line-height: 32px;
            @media (max-width: 1400px) {
                font-size: 1.7142vw;
                line-height: 2.2857vw;
            }
            @media (max-width: 767px) {
                font-size: 20px;
                line-height: 32px;
            }
        }

        > ul {
            margin-top: 24px;
            gap: 24px;
            @media (max-width: 1400px) {
                margin-top: 1.7142vw;
                gap: 1.7142vw;
            }
            @media (max-width: 767px) {
                margin-top: 24px;
                gap: 24px;
            }

            > li {
                gap: 4px;
                @media (max-width: 1400px) {
                    gap: 0.2857vw;
                }
                @media (max-width: 767px) {
                    gap: 4px;
                }

                > h2 {
                    font-size: 20px;
                    line-height: 28px;
                    @media (max-width: 1400px) {
                        font-size: 1.4285vw;
                        line-height: 2vw;
                    }
                    @media (max-width: 767px) {
                        font-size: 18px;
                        line-height: 28px;
                    }
                }

                > p {
                    font-size: 18px;
                    line-height: 28px;
                    @media (max-width: 1400px) {
                        font-size: 1.2857vw;
                        line-height: 2vw;
                    }
                    @media (max-width: 767px) {
                        font-size: 16px;
                        line-height: 28px;
                    }
                }
            }
        }
    }
`